/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Přístup k zdrojům a podpůrným materiálům pro CamAPS FX a CamAPS Liberty®.',
    keywords: 'camaps knihovna, camaps fx, camaps liberty, podpůrné zdroje, řízení diabetu',
    localeMeta: 'cs_cz',

    bannerTitle: 'Podpora nad rámec čísel',
    bannerSubtitle: 's CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Po aktivaci se uživatelé nebudou muset počítat sacharidy a podávat předjídlový inzulínový bolus.',
    bannerCompatibility: 'Kompatibilní s Androidem a iOS',
    
    announcementText: 'Nyní dostupné v myLoop',
    announcementDisclaimer: '',

    introTitle: 'První plně uzavřená smyčka. Když ji potřebujete.',
    introDescription: 'Po aktivaci uživatelé nebudou muset počítat sacharidy a podávat předjídelný inzulínový bolus.',
    introSubtext: 'Dostupné na operačních systémech Android a Apple',

    howItWorksTitle: 'Jak to funguje?',
    howItWorksDescription: 'Poháněno proaktivnější verzí algoritmu CamAPS. CamAPS Liberty předvídá a reaguje na změny glukózy při zachování stanovených bezpečnostních hranic.',
    
    step1Title: 'KROK 1',
    step1Description: 'Z domovské obrazovky přejděte do nabídky nastavení.',
    step2Title: 'KROK 2',
    step2Description: 'Posuňte se dolů na konec a klepněte na přepínač pro aktivaci.',
    step3Title: 'KROK 3',
    step3Description: 'Při prvním použití budete muset zhlédnout naše vysvětlující video o CamAPS Liberty.',
    step4Title: 'KROK 4',
    step4Description: 'Potvrďte, že nemáte méně než 13 let a nejste těhotná.',
    step5Title: 'KROK 5',
    step5Description: 'Klepněte znovu na přepínač pro aktivaci.',
    step6Title: 'KROK 6',
    step6Description: "Vše je připraveno. Karta CamAPS Liberty se zobrazí na vaší domovské obrazovce<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Funguje pouze při zapnutém režimu \"Auto mode\"",

    eligibilityTitle: 'Kdo může používat CamAPS Liberty?',
    eligibilityCriterion1: 'Stávající uživatelé s diabetem 1. typu',
    eligibilityCriterion2: '13 let a starší',
    eligibilityCriterion3: 'Těhotná',
    parentsCarersTitle: 'Co rodiče a pečovatelé?',
    parentsCarersBlockTitle: 'Funkce Blokování:',
    parentsCarersBlockDescription: 'K zabránění náhodnému použití',
    parentsCarersRemoteTitle: 'Vzdálené monitorování:',
    parentsCarersRemoteDescription: 'Companion, Glooko® a dvoutýdenní PDF reporty CamAPS',

    imageOverlayText: 'Navrženo tak, aby fungovalo společně s vaším současným plánem řízení diabetu; ne aby ho nahradilo.',
    
    usingTitle: 'Používání CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty je navržena tak, aby odstranila potřebu rutinního podávání bolusů k jídlu. Nenahrazuje ostatní součásti plánu léčby diabetu uživatele, včetně pravidelných konzultací s diabetologickým týmem.',
    
    usingLibertyTitle: 'Sledujte a seznamte se s CamAPS Liberty',
    usingLibertyDescription: 'Prohlédněte si videa a zjistěte více o CamAPS Liberty a jak začít.',
    // latestVideoLabel removed
    moreVideosLabel: 'Další videa',
    factsheetDownloadText: 'Informační list CamAPS Liberty (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_cz.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Začínáme',
        description: 'Candice Ward vysvětluje, jak nastavit a začít používat CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/_Ihi3FwD8E4',
            title: 'Praktické Tipy: CamAPS Liberty',
            duration: '02:18',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Představení CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Ten pocit fully closed-loop',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/MKOIpXose94',
            title: 'Funkce CamAPS Liberty',
            duration: '03:40',
        }
    ],
    
    whatHappensNextTitle: 'Co se stane dál?',
    whatHappensNextText: 'V nadcházejících měsících spustíme pilotní projekt v jednom trhu. Zůstaňte naladěni pro více podrobností.',
};

